import { zeroUnit } from '@/web-task/utils'

export default function() {
	const res = this.checkParams()
	if (!res) {
		return
	}

	const { order, injured, setting } = this
	let arr = []
	let lawyerInfo = injured.lawyerInfo
	// '0'无律师 '1'超时未选择律师
	let isClosed = ['0', '1'].includes(order.closeType)
	let mediaInfoList = []

	if (lawyerInfo && !isClosed) {
		arr.push(
			{
				label: '姓名',
				value: lawyerInfo.name,
			},
			{
				label: '性别',
				value: setting.sexMap[lawyerInfo.sex],
			},
			{
				label: '联系方式',
				value: lawyerInfo.mobile,
			},
			{
				label: '执业执照',
				value: lawyerInfo.license,
			},
			{
				label: '律所名称',
				value: lawyerInfo.lawOffice,
			},
			{
				label: '执业地区',
				value: lawyerInfo.fullDesc,
			},
			{
				label: '擅长领域',
				value: lawyerInfo.brief,
			},
			{
				label: '综合得分',
				value: zeroUnit(lawyerInfo.score, '分') || '-',
			}
		)

		if (lawyerInfo.formWear) {
			mediaInfoList.push({
				picId: '0',
				picName: '正装照',
				picUrl: lawyerInfo.formWear,
			})
		}
		if (lawyerInfo.identificationPhoto) {
			mediaInfoList.push({
				picId: '1',
				picName: '身份证照',
				picUrl: lawyerInfo.identificationPhoto,
			})
		}
	}

	return {
		title: '律师信息',
		children: arr,
		imageList: mediaInfoList,
	}
}
